import React, { useId } from 'react';
import { X } from 'lucide-react';
import useModal from '../../hooks/useModal';

/**
 * Reusable Modal component with built-in ESC key and click-outside-to-close behavior
 */
const Modal = ({
  isOpen,
  onClose,
  title,
  children,
  maxWidth = 'max-w-2xl',
  showCloseButton = true,
  className = '',
  backdropClassName = 'fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[9999] animate-fade-in'
}) => {
  const titleId = useId();
  const { handleBackdropMouseDown, handleBackdropMouseUp } = useModal(isOpen, onClose);

  if (!isOpen) return null;

  return (
    <div
      className={backdropClassName}
      onMouseDown={handleBackdropMouseDown}
      onMouseUp={handleBackdropMouseUp}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby={title ? titleId : undefined}
        className={`bg-white rounded-2xl shadow-2xl ${maxWidth} w-full mx-4 max-h-[calc(100vh-120px)] overflow-hidden flex flex-col border border-gray-200 animate-modal-slide-up ${className}`}
        onMouseDown={(e) => e.stopPropagation()} // Prevent mousedown inside modal from closing it
      >
        {(title || showCloseButton) && (
          <div className="flex items-center justify-between p-6 border-b border-gray-200 bg-gray-50 flex-shrink-0">
            {title && (
              <h2 id={titleId} className="text-2xl font-bold text-gray-900">{title}</h2>
            )}
            {showCloseButton && (
              <button
                onClick={onClose}
                aria-label="Close"
                className="text-gray-400 hover:text-gray-600 transition-all duration-200 hover:rotate-90 hover:scale-110 p-1 rounded-lg hover:bg-gray-100"
              >
                <X className="h-6 w-6" />
              </button>
            )}
          </div>
        )}

        <div className={`flex-1 overflow-y-auto ${title || showCloseButton ? 'p-6' : ''}`}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
